'use client'

import { useState } from 'react'
import Image from 'next/image'
import LocalizedClientLink from '@modules/common/components/localized-client-link'

export default function NewsListClient({ news_list, buttonLabel }) {
  const [visibleCount, setVisibleCount] = useState(6)

  const showMore = () => {
    setVisibleCount((prev) => prev + 6)
  }

  const hasMore = visibleCount < news_list.length

  return (
    <div className="flex flex-col items-center gap-16">
      <ul className="mx-4 large:mx-auto flex max-w-[1240px] grid-cols-3 flex-col gap-16 large:gap-4 large:gap-y-20 large:grid">
        {news_list.slice(0, visibleCount).map((news, i) => (
          <li
            key={news.documentId || i}
            className="relative grid min-w-[300px] gap-4 overflow-visible"
          >
            <div className="relative row-span-4 aspect-square overflow-hidden rounded">
              <LocalizedClientLink
                href={`/our-news/${news.documentId}`}
                className="block h-full w-full"
              >
                <Image
                  src={news?.thumbnail?.picture?.url || '/default-img.webp'}
                  alt={news?.thumbnail?.picture?.alternativeText ?? 'thumbnail'}
                  width={600}
                  height={600}
                  className="aspect-square object-cover"
                />
                <div className="bg-gradient-overlay-bottom absolute inset-0 z-[10] rounded" />
                <span className="absolute bottom-8 left-8 right-2 z-[20] overflow-hidden text-ellipsis font-playfairDisplay-bold-italic text-white">
                  {news.title}
                </span>
              </LocalizedClientLink>
            </div>

            {/* Date Badge */}
            <div className="pointer-events-none absolute -top-12 right-2 z-[30] h-24 w-24 bg-[url('/background_date.svg')] bg-contain bg-no-repeat">
              <div className="absolute inset-0 flex flex-col items-center justify-center pr-5 font-bebasNeue-regular">
                <span className="font-bebas text-[31px] leading-none text-white">
                  {new Date(news.publication_date).getDate().toString().padStart(2, '0')}
                </span>
                <span className="font-bebas text-[23px] leading-none text-white text-center">
                  {new Intl.DateTimeFormat('fr', { month: 'short' })
                    .format(new Date(news.publication_date))
                    .replace(/\./g, '')
                    .toUpperCase()}
                </span>
              </div>
            </div>

            {news.summary && (
              <p className="large:mb-0 z-[1] line-clamp-3 h-fit overflow-hidden hyphens-auto break-words">
                {news.summary}
              </p>
            )}
          </li>
        ))}
      </ul>

      {hasMore && (
        <button
          onClick={showMore}
          className="rounded-full border-2 border-black px-12 py-3 font-bold uppercase transition-colors hover:bg-black hover:text-white"
        >
          {buttonLabel}
        </button>
      )}
    </div>
  )
}